import router from 'next/router';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { isMobile as isMobileDetect } from 'react-device-detect';
import {
  aplicaEmpresaRegiao,
  aplicaRegiao,
  appendRegiaoQuery,
  filtraEquipeRegiao,
  getRegiaoMatriz,
  getRegiaoSlugFromPath,
  getRegiaoSlugFromQuery,
  isModoPopup,
  normalizeRegioes,
  normalizeRegioesConfig,
  resolveRegiaoAtiva,
  sanitizeRegiaoSlug,
  writeRegiaoCookie,
  type Regiao,
  type RegioesConfig,
} from '../../lib/region';
import { apenasNumeros, formatSelects } from '../../utils/FunctionsGlobals';
import {
  getMarketingConsentFromDocument,
  getMarketingConsentFromLocalStorage,
  resolveMarketingConsentState,
  writeMarketingConsentCookie,
  writeMarketingConsentLocalStorage,
} from '../../utils/marketingConsent';
import {
  clearLegacyHomeStorageKeys,
  getAllDataHomeStorageKey,
  getHomeScopedStorageKey,
  getImoveisLastSearchUrlStorageKey,
  readJsonStorageValue,
  setJsonStorageValue,
} from '../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../utils/storage';
import { condominiosStorageName, filtrarCondominiosCidadeFixa } from '../../utils/condominiosBusca';

/*
 * ---------------------------------------------------------------
 * TIPAGEM
 * ---------------------------------------------------------------
 */

interface AuthData {
  site: {
    fb_token_pixel?: string;
    top_10: boolean;
    redes_topo: boolean;
    internacional: boolean;
    fb_id_pixel: string;
    ocultar_endereco: boolean;
    copyright: boolean;
    EsconderRodapeSobressai?: boolean;
    url_maps: string;
    html_rodape: string;
    titulo_automatico: boolean;
    modelo_pagina_imovel: number;
    modelo_topo: number;
    // SD-0024: botões de WhatsApp de corretor/agenciador vão para o número da imobiliária (utils/whatsappImobiliaria.ts)
    whatsapp_tudo_imobiliaria?: boolean | null;
    // 21/10: seletor de idiomas (GTranslate) e preço na moeda do idioma (utils/idiomaMoedaSite.ts)
    seletor_idioma?: boolean | null;
    preco_moeda_idioma?: boolean | null;
    modelo_cidades: number;
    modelo_busca: number;
    modelo_card: number;
    modelo_depoimento: number;
    modelo_selection: number;
    modelo_empresa: number;
    modelo_blogs: number;
    modelo_redes: number;
    modelo_fundo: number;
    modelo_pesquisa_popular: number;
    modelo_equipe: number;
    /** seção de construtoras parceiras: 0=off (default), 1=carrossel, 2=grade */
    modelo_construtoras: number;
    /** título da seção de construtoras — vazio/null = título padrão do site */
    titulo_construtoras: string | null;
    cards_busca: boolean;
    mostrar_data_entrega: boolean;
    afiliado_todo_site: boolean;
    categoria_home: boolean;
    caracteristicas_home: boolean;
    titulo_card_1: string;
    titulo_card_2: string;
    titulo_card_3: string;
    texto_card_1: string;
    texto_card_2: string;
    texto_card_3: string;
    depoimento_imovel: boolean;
    ver_url: boolean;
    banner_imovel: boolean;
    cidade_priorizada: string;
    /** "Cidade fixa na busca" (tbl_sites.CidadeBusca) — id da cidade pré-selecionada. */
    cidade_busca?: number | string | null;
    texto_botao_whats?: string | null;
    formulario_whats: boolean;
    mostrar_mapa: boolean;
    exibir_empreendimento: boolean;
    moeda_tipo: string;
    simulador: boolean;
    ativa_logs: boolean;
    casa_em_condominio: boolean;
    carousel_temporada: boolean;
    carousel_apartamento: boolean;
    carousel_lancamentos: boolean;
    exibir_cidade_bairro_no_imovel: boolean;
    carousel_casa: boolean;
    carousel_novidades: boolean;
    titulo_c_top: string;
    titulo_c_temporada: string;
    titulo_c_novidades: string;
    titulo_c_casas: string;
    titulo_c_1: string;
    titulo_c_2: string;
    titulo_c_c_condominio: string;
    titulo_c_apartamentos: string;
    id: number;
    modelo_novo: string;
    ordenar_lista: string;
    mostrar_visualizacoes: boolean;
    site: string;
    titulo: string;
    meta_keywords: string;
    meta_description: string;
    url_logo: string;
    url_icon: string;
    url_video: string;
    rodape: number;
    texto_rodape: string;
    cor1: string;
    cor2: string;
    cor3: string;
    cor4: string;
    cor5: string;
    cor6: string;
    cor7: string;
    cor8: string;
    cor9: string;
    cor10: string;
    cor11: string;
    cor12: string;
    cor13: string;
    cor14: string;
    cor15: string;
    vgv_total: string
    total_imoveis: number
    total_cidades: number
    exibe_redes_sociais: boolean;
    congelado: boolean;
    qtd_fotos_bloqueios: number;
    bloquear_fotos: number;
    pixel_facebook_head: string;
    link_chat_body: string;
    link_chat_head: string;
    tag_google_head: string;
    tag_google_body: string;
    google_analytics_body: string;
    google_analytics_head: string;
    libera_fts_aluguel: string;
    banner_home?: string | null;
    carrossel_corretores: string;
    frase_busca: string;
    frase_busca_2: string;
    tamanho_logo: number;
    logo_horizontal: boolean;
    navbar_transparente: boolean;
    transacoes: string[];
    contador_marca: number;
    politica_privacidade: string;
    termos_uso: string;
    promocao: boolean;
    Dados: {
      inicio_txt_descricao: string;
      delegar_ao_agenciador?: boolean | null;
      horario: string;
      final_txt_descricao: string;
      empresa: string;
      email1: string;
      email2: string;
      email3?: string | null;
      email4?: string | null;
      tel1: string;
      tel2: string;
      tel3: string;
      tel4: string;
      tel1_nome: string;
      tel2_nome: string;
      tel3_nome: string;
      tel4_nome: string;
      tel1_whats: boolean;
      tel2_whats: boolean;
      tel3_whats: boolean;
      tel4_whats: boolean;
      endereco: string;
      cidade: string;
      bairro: string;
      creci: string;
      youtube: string;
      facebook: string;
      twitter: string;
      instagram: string;
      Linkedin: string;
      threads: string;
      tiktok: string;
    };
    video: boolean;
    widget_youtube: string;
    widget_instagram: string;
    marca_dagua: {
      opacidade: number;
      posicao: string;
      ativada: number;
      tamanho_marca: number;
    };
    exibir_agenciador: boolean;
  };
  videos: {
    url_youtube: string;
    excluido: boolean;
  }[];
   blogs: {
      id: number;
      url_foto: string;
      autor: string;
      titulo: string;
      texto: string;
      excluido: boolean;
      data_cadastro: string;
      id_cidade: number;
      id_empreendimento: number;
      categoria: string;
      id_categoria: number;
  }[];
  rodape: {
    tipo: string;
    cidade: string;
    bairro: string;
    dormitorios: string | null;
    aluguel: number;
    venda: number;
    empreendimento?: string | null;
  }[];
  allBanners: {
    id: number;
    codsite: number;
    exibir: string;
    ordem: number;
    extensao: string;
    titulo: string;
    url: string;
    url_link: string;
    message: string;
    ativo: boolean;
  }[];
  banner_empresa?: {
    linkbanner: string;
    card_titulo: string;
    subtitulo_1: string;
    paragrafo_1: string;
    subtitulo_2: string;
    paragrafo_2: string;
    subtitulo_3: string;
    paragrafo_3: string;
    corconfig: string;
  } | null;
  menus: {
    link: string;
    titulo: string;
    Destino: string;
    Disponivel: number;
    Menu: number;
    Rodape: number;
    Topo: number;
    Conteudo: string;
    /** só na home (site-props `menuLeveDaHome`) e só no item com o marcador do Anuncie com IA válido. */
    anuncieIa?: true;
  }[];
  cidades: {
    id: number;
    nome: string;
    id_estado: number;
    url_foto: string;
  }[];
  tipos: {
    id: number;
    nome: string;
  }[];
  redes_sociais: {
      nome: string
      href: string
      imagem: string
      seguidores: string
      arroba: string
  }[];
  /** construtoras parceiras COM logo (o backend já filtra) — vitrine da home */
  construtoras: {
    id: number;
    nome: string | null;
    url_foto: string | null;
  }[];
  parceiros: {
    id: number;
    nome: string;
    contador_atualizacao: number;
    telefone: string;
    telefone_2?: string | null;
    email: string;
    mostrar_equipe: boolean;
    descricao?: string | null;
    funcao: {
      id: number;
      nome: string;
    } | null;
    url_foto: string;
    creci: string;
    link_proprio?: string | null;
    linkedin?: string | null;
    instagram?: string | null;
    facebook?: string | null;
  }[];
  depoimentos: {
    depoimento: string;
    youtube: string;
    cliente: {
      nome: string;
      foto?: string | null;
    };
  }[];
  precos_locacao: {
    min: number;
    max: number;
  }[];
  precos_venda: {
    min: number;
    max: number;
  }[];
  // MULTI-REGIÃO: regiões ativas do tenant (query pública `regioes`); ausente/vazio
  // = tenant sem multi-região. Anexado ao payload no SSR (site-props.loadRegioes).
  regioes?: any[];
  // MULTI-FILIAIS: filiais de cada corretor da equipe ({ "<parceiroId>": [filialId] }),
  // do mesmo documento fail-safe das regiões. Ausente = backend ainda sem o campo.
  regioesEquipe?: Record<string, number[]>;
  // MULTI-FILIAIS: modo de entrada do site (barra = V1 | popup = matriz default).
  regioesConfig?: any;
  carrosseis: {
    id: number;
    id_bairro: number;
    id_tipo: number;
    id_categoria: number;
    id_cidade: number;
    id_caracteristica: number;
    id_empreendimento: number;
    preco_min: number;
    preco_max: number;
    titulo: String;
    top_10: Boolean;
    url_red: String;
    novidades_semana: Boolean;
    personalizado: Boolean;
    exclusivos: Boolean;
    venda: Boolean;
    aluguel: Boolean;
    cor_fundo: String;
    cor_degrade: String;
    cor_font: String;
    cor_botoes: String;
  }[];
}

export interface AuthContextType {
  allDataHome: AuthData | null;
  init_props: any;
  favorito: any;
  allViewProperties: any;
  allCompany: any;
  isMobile1: boolean;
  setFavorito: (_favs: any[]) => void;
  setAllViewProperties: (_value: any[]) => void;
  setAllCompany: (_value: any) => void;
  allCarrosseis: any;
  setAllCarrosseis: (_value: any) => void;
  setGetOnlyQuery1: (_value: any) => void;
  listCategory: any;
  getOnlyQuery1: any;
  all_cards_home: any;
  setListCategory: (_value: any) => void;
  listEstados: any;
  setListEstados: (_value: any) => void;
  listCaracteristicas: any;
  setListCaracteristicas: (_value: any) => void;
  listDatas: any;
  setListDatas: (_value: any) => void;
  include_favorito: (_imovel: any) => void;
  include_visualizado: (_imovel: any) => void;
  delete_favorito: (_imovel: any) => void;
  setUltimaConsulta: (_value: any) => void;
  ultimaConsulta: any;
  politic: null | 'accepted' | 'rejected' | 'nao';
  setPolitic: (_value: null | 'accepted' | 'rejected' | 'nao') => void;
  // MULTI-REGIÃO
  regioes: Regiao[];
  regiaoAtiva: Regiao | null;
  setRegiao: (_slug: string | null) => void;
  // MULTI-FILIAIS: vínculo corretor→filiais (para recortar a equipe por região).
  regioesEquipe: Record<string, number[]>;
  regioesConfig: RegioesConfig | null;
  regiaoMatriz: Regiao | null;
  /** portão do comportamento novo: modoEntrada='popup' + existe matriz. */
  modoPopup: boolean;
  filialPopupAberto: boolean;
  setFilialPopupAberto: (_aberto: boolean) => void;
}

/* ---------- CONTEXTO ---------- */
const AuthContext = createContext<AuthContextType | undefined>(undefined);

/* ---------- PROVIDER ---------- */
export const AuthProvider = ({
  children,
  init_props,
  allDataHome: allDataHomeProp,
}: Partial<AuthContextType> & { children: ReactNode }) => {
    const [favorito, setFavorito] = useState<Array<number>>([]);
    const [allViewProperties, setAllViewProperties] = useState<Array<number>>([]);
    const isMobile1 = init_props?.isMobile || isMobileDetect;

    const [allDataHome, setAllDataHome] = useState<AuthData | null>(allDataHomeProp || null);
    const [allCompany, setAllCompany] = useState(
        init_props?.all_company?.empreendimentos
        ? formatSelects(init_props?.all_company?.empreendimentos)
        : []
    );
    const [allCarrosseis, setAllCarrosseis] = useState(
        init_props?.all_carrosseis || []
    );
    const [getOnlyQuery1, setGetOnlyQuery1] = useState<any[]>([]);
    const [all_cards_home, setAll_cards_home] = useState<any[]>(init_props?.allCards);
    const [listCategory, setListCategory] = useState<any>(0);
    const [listEstados, setListEstados] = useState<any>(0);
    const [listCaracteristicas, setListCaracteristicas] = useState<any>(0);
    const [listDatas, setListDatas] = useState<any>(0);
    const [ultimaConsulta, setUltimaConsulta] = useState<any>('');
    const TTL1 = 60 * 30 * 1000; // 1 horas
    // Semeia do consentimento lido no SERVIDOR (init_props.initialPolitic via req.cookie)
    // p/ o banner poder renderizar no SSR (LCP). Sem seed = null (comportamento antigo:
    // banner só client-side). O efeito abaixo reconcilia com cookie+localStorage reais.
    const [politic, setPoliticState] = useState<null | 'accepted' | 'rejected' | 'nao'>(
        (init_props?.initialPolitic as 'accepted' | 'rejected' | 'nao' | undefined) ?? null
    );
    const storageHost = useMemo(
      () =>
        init_props?.prodOrigin ||
        init_props?.origemInit ||
        allDataHomeProp?.site?.site ||
        allDataHome?.site?.site ||
        (typeof window !== 'undefined' ? window.location.host : ''),
      [allDataHome?.site?.site, allDataHomeProp?.site?.site, init_props?.origemInit, init_props?.prodOrigin]
    );
    const storageCodsite = useMemo(
      () => init_props?.codsite || allDataHomeProp?.site?.id || allDataHome?.site?.id || 0,
      [allDataHome?.site?.id, allDataHomeProp?.site?.id, init_props?.codsite]
    );
    const allDataHomeStorageKey = useMemo(
      () => getAllDataHomeStorageKey(storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const condosStorageKey = useMemo(
      () => getHomeScopedStorageKey(condominiosStorageName(storageCodsite), storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const cardsStorageKey = useMemo(
      () => getHomeScopedStorageKey('all_cards', storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const lastSearchUrlStorageKey = useMemo(
      () => getImoveisLastSearchUrlStorageKey(storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );

    useEffect(() => {
      if (!allDataHomeProp) return;
      setAllDataHome(allDataHomeProp as AuthData);
      setJsonStorageValue(localStorage, allDataHomeStorageKey, allDataHomeProp);
      localStorage.removeItem('allDataHome');
    }, [allDataHomeProp, allDataHomeStorageKey]);

    useEffect(() => {
      if (!Array.isArray(init_props?.all_carrosseis)) return;
      setAllCarrosseis(init_props.all_carrosseis);
    }, [init_props?.all_carrosseis]);
    
    // Mantem cookie e localStorage sincronizados para o SSR conseguir ler o consentimento.
    useEffect(() => {
        const cookieConsent = getMarketingConsentFromDocument();
        const storageConsent = getMarketingConsentFromLocalStorage();
        const resolvedConsent = resolveMarketingConsentState(cookieConsent, storageConsent);

        clearLegacyHomeStorageKeys(localStorage);
        setPoliticState(resolvedConsent);
        writeMarketingConsentLocalStorage(resolvedConsent);
        writeMarketingConsentCookie(resolvedConsent);

        const { favoritos } = router.query;
        if(favoritos){
            setFavorito(favoritos ? apenasNumeros(favoritos) : [])
        } else {
          const savedFavoritos = readJsonStorageValue<any[]>(localStorage, 'favoritos', []);
          if (savedFavoritos.length > 0) {
              setFavorito(savedFavoritos);
          }
        }
        const savedViews = readJsonStorageValue<any[]>(localStorage, 'allViewProperties', []);
        if (savedViews.length > 0) {
            setAllViewProperties(savedViews);
        }
    }, []);

    useEffect(() => {
        if(allDataHome?.site?.cards_busca == true && init_props?.allCards){
          setJsonStorageValue(localStorage, cardsStorageKey, init_props?.allCards);
          localStorage.removeItem('all_cards');
        } else {
          if(allDataHome?.site?.cards_busca == true){
            const allCardsCached = readJsonStorageValue<any[]>(localStorage, cardsStorageKey, []);
            if(allCardsCached.length > 0)
              setAll_cards_home(allCardsCached);
          }
        }
    }, [allDataHome?.site?.cards_busca, cardsStorageKey, init_props?.allCards]);

    /* --------------------------------------------------
    * MULTI-REGIÃO
    * -------------------------------------------------- */
    // Lista de regiões do tenant (viaja dentro do payload allDataHome.regioes).
    const regioes = useMemo<Regiao[]>(
      () => normalizeRegioes((allDataHome as any)?.regioes || (allDataHomeProp as any)?.regioes),
      [allDataHome, allDataHomeProp]
    );
    // MULTI-FILIAIS: vínculo corretor→filiais (mesmo documento fail-safe das
    // regiões). Sem o campo no backend fica {} e o recorte de equipe é NO-OP.
    const regioesEquipe = useMemo<Record<string, number[]>>(
      () =>
        ((allDataHome as any)?.regioesEquipe ||
          (allDataHomeProp as any)?.regioesEquipe ||
          {}) as Record<string, number[]>,
      [allDataHome, allDataHomeProp]
    );
    // MULTI-FILIAIS: modo de entrada do tenant. Sem o campo no backend fica null
    // ⇒ modoPopup=false ⇒ tudo que é V2 desliga (o site fica na barra da V1).
    const regioesConfig = useMemo<RegioesConfig | null>(() => {
      const raw = (allDataHome as any)?.regioesConfig || (allDataHomeProp as any)?.regioesConfig;
      return raw ? normalizeRegioesConfig(raw) : null;
    }, [allDataHome, allDataHomeProp]);
    const regiaoMatriz = useMemo(() => getRegiaoMatriz(regioes), [regioes]);
    const modoPopup = useMemo(() => isModoPopup(regioes, regioesConfig), [regioes, regioesConfig]);
    // lembrarDias = 0 significa "não lembrar" → 0 segundos → cookie de SESSÃO
    // (por isso `?? 90` e não `|| 90`: o zero é um valor legítimo).
    const cookieMaxAgeSec = useMemo(() => {
      const dias = regioesConfig?.lembrarDias;
      const efetivo = typeof dias === 'number' && dias >= 0 ? dias : 90;
      return efetivo * 24 * 60 * 60;
    }, [regioesConfig?.lembrarDias]);

    // Popup de filiais: só o estado de aberto/fechado mora aqui (o componente é
    // client-only e pode ser aberto de vários pontos — pill do topo, barra).
    const [filialPopupAberto, setFilialPopupAberto] = useState(false);

    // Seed do SSR (init_props.regiaoAtiva — path /r/<slug>, ?regiao= ou a MATRIZ
    // no modo popup) pro HTML do servidor e a 1ª render do cliente baterem (sem
    // hydration mismatch). Região vinda SÓ de cookie entra depois, no efeito de
    // reconciliação abaixo.
    const [regiaoAtiva, setRegiaoAtivaState] = useState<Regiao | null>(() => {
      const seed = (init_props as any)?.regiaoAtiva;
      if (!seed?.slug) return null;
      return normalizeRegioes([seed])[0] || null;
    });

    // Reconcilia com os sinais do browser (path > ?regiao= > cookie > matriz) na
    // montagem e a cada navegação client-side.
    useEffect(() => {
      const syncRegiao = () => {
        if (typeof window === 'undefined') return;
        if (!regioes.length) {
          setRegiaoAtivaState(null);
          return;
        }
        const found = resolveRegiaoAtiva(
          regioes,
          {
            path: window.location.pathname,
            query: window.location.search,
            cookie: document.cookie,
          },
          regioesConfig
        );
        setRegiaoAtivaState((prev) => (prev?.slug === found?.slug ? prev : found));
        const slugDaUrl =
          getRegiaoSlugFromPath(window.location.pathname) ||
          getRegiaoSlugFromQuery(window.location.search);
        if (modoPopup) {
          // V2: depois que o JS roda o cookie SEMPRE reflete a filial efetiva —
          // inclusive o default (matriz). "1ª visita" é flag separada
          // (localStorage filial_popup_visto), não a ausência do cookie.
          if (found) writeRegiaoCookie(found.slug, cookieMaxAgeSec);
        } else if (found && slugDaUrl === found.slug) {
          // V1 (barra): só persiste o que veio explícito na URL.
          writeRegiaoCookie(found.slug);
        }
      };
      syncRegiao();
      router.events.on('routeChangeComplete', syncRegiao);
      return () => {
        router.events.off('routeChangeComplete', syncRegiao);
      };
    }, [regioes, regioesConfig, modoPopup, cookieMaxAgeSec]);

    // Troca de filial/região: grava o cookie e leva a URL junto.
    //  • modo popup, na HOME (`/` ou `/r/<slug>`): navega `/` ↔ `/r/<slug>` —
    //    a matriz é a raiz limpa, as demais têm caminho próprio (SSR/CDN).
    //  • demais páginas: só atualiza `?regiao=` (shallow), removendo o parâmetro
    //    quando a escolha é a matriz.
    //  • modo barra (V1): comportamento anterior, byte a byte.
    const setRegiao = useCallback((_slug: string | null) => {
      const alvo = _slug
        ? regioes.find((r) => r.slug === sanitizeRegiaoSlug(_slug)) || null
        : null;
      setRegiaoAtivaState(alvo);
      if (modoPopup) {
        // sem alvo, no modo popup, a escolha efetiva é a matriz
        const efetiva = alvo || regiaoMatriz;
        writeRegiaoCookie(efetiva ? efetiva.slug : null, cookieMaxAgeSec);
      } else {
        writeRegiaoCookie(alvo ? alvo.slug : null);
      }
      if (typeof window === 'undefined') return;
      const { pathname, search } = window.location;
      const ehMatriz = Boolean(alvo && regiaoMatriz && alvo.slug === regiaoMatriz.slug);
      const naHome = pathname === '/' || /^\/r\/[^/]+\/?$/.test(pathname);

      if (modoPopup && naHome) {
        // preserva o resto da query (?codsite=/?tema= dos hosts de teste)
        const params = new URLSearchParams(search);
        params.delete('regiao');
        const qs = params.toString();
        const destino = !alvo || ehMatriz ? '/' : `/r/${alvo.slug}`;
        void router.push(`${destino}${qs ? `?${qs}` : ''}`);
        return;
      }

      if (!modoPopup && /^\/r(\/|$)/.test(pathname)) {
        void router.push(alvo ? `/r/${alvo.slug}` : '/');
        return;
      }

      const params = new URLSearchParams(search);
      if (alvo && !ehMatriz) params.set('regiao', alvo.slug);
      else params.delete('regiao');
      const qs = params.toString();
      void router.push(`${pathname}${qs ? `?${qs}` : ''}`, undefined, {
        shallow: true,
        scroll: false,
      });
    }, [regioes, modoPopup, regiaoMatriz, cookieMaxAgeSec]);


    // Cache local dos carrosséis da home. MULTI-FILIAIS: a chave leva o slug da
    // região ativa — sem isso os carrosséis de uma filial vazariam para a outra
    // (o conteúdo passou a ser recortado por cidade no SSR). Sem região o slug
    // é '' e o helper descarta a parte vazia ⇒ chave IDÊNTICA à de hoje.
    useEffect(() => {
        if(allCarrosseis?.length > 0){
          setWithTTL(
            getHomeScopedStorageKey(
              'all_carrosseis',
              storageHost,
              storageCodsite,
              allDataHome?.carrosseis?.length || 0,
              regiaoAtiva?.slug || ''
            ),
            allCarrosseis,
            TTL1
          );
        }
    }, [allCarrosseis, allDataHome?.carrosseis?.length, TTL1, storageCodsite, storageHost, regiaoAtiva?.slug]);

    // Salva o consentimento nos dois storages para manter compatibilidade cliente/SSR.
    const setPolitic = useCallback((_value: null | 'accepted' | 'rejected' | 'nao') => {
        setPoliticState(_value);
        writeMarketingConsentLocalStorage(_value);
        writeMarketingConsentCookie(_value);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('politic-change'));
        }
    }, [setPoliticState]);

    /* --------------------------------------------------
    * FAVORITOS
    * -------------------------------------------------- */
    useEffect(() => {
        if (favorito.length === 0) {
              localStorage.removeItem('favoritos');
        } else {
          setJsonStorageValue(localStorage, 'favoritos', favorito);
        }
    }, [favorito]);

    useEffect(() => {
        if (allViewProperties?.length == 0) {
          localStorage.removeItem('allViewProperties');
        } else {
          setJsonStorageValue(localStorage, 'allViewProperties', allViewProperties);
        }
    }, [allViewProperties]);

    /* --------------------------------------------------
    * ÚLTIMA CONSULTA + TTL
    * -------------------------------------------------- */
    useEffect(() => {
        if (ultimaConsulta) {
          setJsonStorageValue(localStorage, lastSearchUrlStorageKey, ultimaConsulta);
        } else {
          const ultima = readJsonStorageValue<string | null>(localStorage, lastSearchUrlStorageKey, null);
          if (typeof ultima === 'string' && ultima) {
              const ultimaProp = getWithTTL<any>(`ultima_consulta:${ultima}`);
              // Só re-hidrata se a busca salva for VÁLIDA e NÃO-VAZIA. Um resultado
              // salvo vazio/corrompido (ex.: {imoveis:[],count:0}) envenenava o estado
              // e levava a tela de busca a um loop infinito — então descartamos.
              const ultimaValida =
                  ultimaProp && typeof ultimaProp === 'object' &&
                  Array.isArray(ultimaProp.imoveis) && ultimaProp.imoveis.length > 0;
              if (ultimaValida) {
                  setUltimaConsulta(ultima);
              } else {
                  localStorage.removeItem(lastSearchUrlStorageKey);
                  localStorage.removeItem(`ultima_consulta:${ultima}`);
              }
          }
        }
    }, [lastSearchUrlStorageKey, ultimaConsulta]);

    /* --------------------------------------------------
    * FUNÇÃO PARA BUSCAR DADOS DO SITE
    * -------------------------------------------------- */

    /* --------------------------------------------------
    * CARREGA CONDOMÍNIOS / ALLDATAHOME
    * -------------------------------------------------- */
    useEffect(() => {
        if (allCompany.length === 0 && allDataHome?.site.exibir_empreendimento) {
        const timeout = setTimeout(() => {
            const cached = readJsonStorageValue<any>(localStorage, condosStorageKey, []);
            if (Array.isArray(cached) && cached.length > 0) {
              setAllCompany(cached);
              return;
            }
            if (cached?.empreendimentos?.length > 0) {
              setAllCompany(formatSelects(filtrarCondominiosCidadeFixa(
                cached.empreendimentos,
                allDataHome?.site?.id,
                allDataHome?.site?.cidade_busca,
              )));
            }
        }, 1000);
        return () => clearTimeout(timeout);
        } else if (allCompany.length > 0) {
        setJsonStorageValue(localStorage, condosStorageKey, allCompany);
        localStorage.removeItem('condominios');
        }

        if (allDataHome) {
          setJsonStorageValue(localStorage, allDataHomeStorageKey, allDataHome);
          localStorage.removeItem('allDataHome');
        } else {
          const cached = readJsonStorageValue<AuthData | null>(localStorage, allDataHomeStorageKey, null);
          if (cached) {
            setAllDataHome(cached);
          }
        }
    }, [allCompany, allDataHome, allDataHomeStorageKey, condosStorageKey]);

    /* --------------------------------------------------
    * FUNÇÕES DE FAVORITOS
    * -------------------------------------------------- */
    const include_favorito = useCallback((_imovel: any) => {
        setFavorito((prev) => prev.concat(_imovel));
    }, []);

    const include_visualizado = useCallback((_imovel: any) => {
      if(_imovel)
        setAllViewProperties((prev) => prev.concat(_imovel));
    }, []);

    const delete_favorito = useCallback((_imovel: any) => {
      setFavorito((prev) => {
        if(prev?.length <= 1)
          return [];
        else
          return prev.filter((id) => id !== _imovel);
      });
    }, []);

    /* --------------------------------------------------
    * CONTEXTO MEMOIZADO
    * -------------------------------------------------- */
    const ctxValue = useMemo<AuthContextType>(
        () => ({
            init_props: init_props || null,
            allDataHome: allDataHome || null,
            favorito,
            setAllViewProperties,
            allViewProperties,
            listCategory,
            ultimaConsulta,
            setListCategory,
            setUltimaConsulta,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            setAllCarrosseis,
            allCarrosseis,
            setGetOnlyQuery1,
            all_cards_home,
            getOnlyQuery1,
            allCompany,
            isMobile1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic,
            regioes,
            regiaoAtiva,
            setRegiao,
            regioesEquipe,
            regioesConfig,
            regiaoMatriz,
            modoPopup,
            filialPopupAberto,
            setFilialPopupAberto
          }),
        [
            ultimaConsulta,
            setUltimaConsulta,
            init_props,
            isMobile1,
            setAllViewProperties,
            allViewProperties,
            allDataHome,
            allCompany,
            favorito,
            listCategory,
            setListCategory,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            allCarrosseis,
            setAllCarrosseis,
            getOnlyQuery1,
            all_cards_home,
            setGetOnlyQuery1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic,
            regioes,
            regiaoAtiva,
            setRegiao,
            regioesEquipe,
            regioesConfig,
            regiaoMatriz,
            modoPopup,
            filialPopupAberto
        ]
    );

  return <AuthContext.Provider value={ctxValue}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};

/** `site` do contexto sem lançar fora do provider (peças pequenas, ex.: PrecoMoeda, IdiomaOculto). */
export const useSiteOpcional = (): any => useContext(AuthContext)?.allDataHome?.site;

/* --------------------------------------------------
 * MULTI-REGIÃO — hooks utilitários
 * -------------------------------------------------- */

// Objeto estável: evita recriar {} a cada render e invalidar memos de quem consome.
const EQUIPE_VAZIA: Record<string, number[]> = {};

// Versão tolerante (não lança fora do provider — ex.: Storybook): sem contexto,
// devolve o estado neutro (sem regiões) e o site segue como mono-região.
export const useRegiao = (): {
  regioes: Regiao[];
  regiaoAtiva: Regiao | null;
  setRegiao: (_slug: string | null) => void;
  regioesEquipe: Record<string, number[]>;
  regioesConfig: RegioesConfig | null;
  regiaoMatriz: Regiao | null;
  modoPopup: boolean;
  filialPopupAberto: boolean;
  setFilialPopupAberto: (_aberto: boolean) => void;
} => {
  const ctx = useContext(AuthContext);
  return {
    regioes: ctx?.regioes || [],
    regiaoAtiva: ctx?.regiaoAtiva || null,
    setRegiao: ctx?.setRegiao || (() => undefined),
    regioesEquipe: ctx?.regioesEquipe || EQUIPE_VAZIA,
    regioesConfig: ctx?.regioesConfig || null,
    regiaoMatriz: ctx?.regiaoMatriz || null,
    modoPopup: Boolean(ctx?.modoPopup),
    filialPopupAberto: Boolean(ctx?.filialPopupAberto),
    setFilialPopupAberto: ctx?.setFilialPopupAberto || (() => undefined),
  };
};

// Href que PRESERVA a filial ativa nos links internos: acrescenta `?regiao=`
// quando a região ativa não é a matriz. NUNCA em ficha de imóvel, em `/r/...`
// nem em link externo (ver appendRegiaoQuery). Só depois de montado, para o
// href do SSR e o da 1ª render do cliente serem idênticos (hydration).
export const useRegiaoHref = (): ((_href?: string | null) => string) => {
  const { regiaoAtiva, regiaoMatriz, modoPopup } = useRegiao();
  const [montado, setMontado] = useState(false);
  useEffect(() => {
    setMontado(true);
  }, []);
  return useCallback(
    (_href?: string | null) => {
      const href = String(_href ?? '');
      if (!montado || !modoPopup) return href;
      return appendRegiaoQuery(href, regiaoAtiva, regiaoMatriz?.slug || null);
    },
    [montado, modoPopup, regiaoAtiva, regiaoMatriz]
  );
};

// Aplica a região ativa sobre o `site`: CONTATO (tel1/tel2/email1 dos Dados),
// VÍDEO do hero (url_video + flag url_video_regional) e TÍTULO/SUBTÍTULO
// (frase_busca/frase_busca_2), sem mudar a estrutura consumida pelos
// componentes. Sem região (ou região sem nenhum desses campos) devolve o MESMO
// objeto — zero efeito em tenant mono-região.
export const useSiteRegiao = (site: any): any => {
  const { regiaoAtiva } = useRegiao();
  return useMemo(() => aplicaRegiao(site, regiaoAtiva), [site, regiaoAtiva]);
};

// "Nossa Empresa" (banner_empresa) com a foto/título da filial ativa, quando ela
// tem os seus. Trocar de filial troca a foto da equipe; filial sem foto (ou
// tenant sem filiais) = o MESMO objeto de entrada.
export const useEmpresaRegiao = <T,>(empresa: T): T => {
  const { regiaoAtiva } = useRegiao();
  return useMemo(() => aplicaEmpresaRegiao(empresa, regiaoAtiva), [empresa, regiaoAtiva]);
};

// Recorte da EQUIPE pela filial da região ativa. Região sem filial vinculada →
// lista intacta; corretor sem filial nenhuma → aparece em todas as regiões.
export const useEquipeRegiao = <T,>(parceiros: T[] | null | undefined): T[] => {
  const { regiaoAtiva, regioesEquipe } = useRegiao();
  return useMemo(
    () => filtraEquipeRegiao(parceiros, regiaoAtiva, regioesEquipe),
    [parceiros, regiaoAtiva, regioesEquipe]
  );
};
